import { render } from "./ImageViewer.vue?vue&type=template&id=5b08d13e&scoped=true&bindings={}"
import script from "./ImageViewer.vue?vue&type=script&lang=ts"
export * from "./ImageViewer.vue?vue&type=script&lang=ts"

import "./ImageViewer.vue?vue&type=style&index=0&id=5b08d13e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b08d13e"

export default script